const TradeMark = () => {
  return (
    <p className="fixed right-0 bottom-0 p-[20px] text-[15px] text-white text-opacity-30">
      Developed by{" "}
      <a
        href="https://theshawa-dev.web.app"
        className="font-medium hover:underline"
      >
        Theshawa Dasun
      </a>
    </p>
  );
};

export default TradeMark;
